var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExport = function SvgIconExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.258 6.425 1.908-1.917V12.5a.833.833 0 1 0 1.667 0V4.508l1.908 1.917a.834.834 0 0 0 1.366-.271.83.83 0 0 0-.183-.912l-3.333-3.334a.8.8 0 0 0-.275-.175.83.83 0 0 0-.633 0 .8.8 0 0 0-.275.175L6.074 5.242a.837.837 0 0 0 1.184 1.183m10.241 5.242a.833.833 0 0 0-.833.833v3.333a.833.833 0 0 1-.833.834H4.166a.834.834 0 0 1-.833-.834V12.5a.833.833 0 0 0-1.667 0v3.333a2.5 2.5 0 0 0 2.5 2.5h11.667a2.5 2.5 0 0 0 2.5-2.5V12.5a.833.833 0 0 0-.834-.833"
  })));
};
export default SvgIconExport;